// extracted by mini-css-extract-plugin
export var container = "problems-module--container--56200";
export var problemWrapper = "problems-module--problemWrapper--740d5";